<template>
  <v-row justify="center">
    <v-dialog v-model="confirm" persistent :max-width="width">
      <v-card>
        <v-card-title class="headline">{{title}}</v-card-title>
        <v-card-text class="subtitle-1" v-html="message"></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="warning" outlined @click="okay()">Okay</v-btn>
          <v-btn color="grey" outlined @click="cancel()">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data: () => ({}),
  /*data() {
    return {
      loading: false,
      expandedMember: this.expanded
    };
  },*/
  created() {},
  mounted() {},
  computed: {},
  methods: {
    okay() {
      if (this.callback && typeof this.callback === 'function') {
        this.callback();
      }
      this.$emit("update:confirm", false);
    },
    cancel() {
      this.$emit("update:confirm", false);
    }
  },
  watch: {},
  props: {
    confirm: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Confirm'
    },
    message: {
      type: String,
      default: 'Are you sure you want to perform this action?'
    },
    callback: {
      type: Function,
      default: null
    },
    width: {
      type: [Number, String],
      default: 300
    }
  }
};
</script>

<style lang="scss" scoped>
</style>